import { convertTag } from 'global/utils/convertTag';
import React from 'react';
import { ProductTemplateStatus } from 'types/productServiceV2';
import {
  PRODUCT_TEMPLATES_IN_PROGRESS_STATUS_TAG_TEST_ID,
  PRODUCT_TEMPLATES_READY_STATUS_TAG_TEST_ID,
  PRODUCT_TEMPLATES_ARCHIVE_STATUS_TAG_TEST_ID,
  PRODUCT_TEMPLATES_INITIAL_SEED_STATUS_TAG_TEST_ID,
} from 'components/rfq/product-template/constants';
import { StatusTagWrapper } from './styles';

export interface StatusTagProps {
  status: ProductTemplateStatus;
  className?: string;
}

const statusTestIdMap: Record<ProductTemplateStatus, string> = {
  [ProductTemplateStatus.IN_PROGRESS]: PRODUCT_TEMPLATES_IN_PROGRESS_STATUS_TAG_TEST_ID,
  [ProductTemplateStatus.READY]: PRODUCT_TEMPLATES_READY_STATUS_TAG_TEST_ID,
  [ProductTemplateStatus.ARCHIVE]: PRODUCT_TEMPLATES_ARCHIVE_STATUS_TAG_TEST_ID,
  [ProductTemplateStatus.INITIAL_SEED]: PRODUCT_TEMPLATES_INITIAL_SEED_STATUS_TAG_TEST_ID,
};

const StatusTag = ({ status, className }: StatusTagProps): JSX.Element => {
  return (
    <StatusTagWrapper $status={status} className={className} data-test-id={statusTestIdMap[status]}>
      {convertTag(status)}
    </StatusTagWrapper>
  );
};

export default StatusTag;
